const BASE = '/sales/payment-orders'

export const salesPaymentOrdersEndpoints = {
  BASE,
  BEFORE: `${BASE}/before`,
  LIST: `${BASE}/list`,
  ONE: `${BASE}/onePaymentOrder`,
  CREATE: `${BASE}/create`,
  UPDATE: BASE,
  DELETE: `${BASE}/paymentorder`,
  ADD_ITEM: `${BASE}/addPaymentOrderItem`,
  EDIT_ITEM: `${BASE}/editpaymentorder`,
  DELETE_ITEM: `${BASE}/paymentorderitem`,
  INVOICE: `${BASE}/invoice`,
  ASSOCIATE_COMP: `${BASE}/associatecomp`,
  UNASSOCIATE_COMP: `${BASE}/unassociatecomp`,
  GENERATE_ORDER: `${BASE}/generateorder`,
  EXPORT: `${BASE}/export`,
}
